import React from "react";
import ProductionsGenericSkeleton from "./ProductionsGenericSkeleton";

function ProductionsDetailSkeleton() {
  return (
    <>
      <ProductionsGenericSkeleton />
    </>
  );
}

export default ProductionsDetailSkeleton;
